import { render, staticRenderFns } from "./OTTzanting.vue?vue&type=template&id=4bf6a7c5&scoped=true&"
import script from "./OTTzanting.vue?vue&type=script&lang=ts&"
export * from "./OTTzanting.vue?vue&type=script&lang=ts&"
import style0 from "./OTTzanting.vue?vue&type=style&index=0&id=4bf6a7c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf6a7c5",
  null
  
)

export default component.exports